import React from "react";
import "../../../Rfid/rfid_bulk_upload/RfidUploadedErrorTable.css";

const COLUMNS = [
  { key: "rowNumber", label: "Row" },
  { key: "employeeName", label: "Employee Name" },
  { key: "department", label: "Department" },
  { key: "designation", label: "Designation" },
  { key: "zone", label: "Zone" },
  { key: "ward", label: "Ward" },
  { key: "identityType", label: "Identity Type" },
  { key: "identityNo", label: "Identity No" },
  { key: "gender", label: "Gender" },
  { key: "contactNo", label: "Contact No" },
  { key: "dateOfBirth", label: "Date Of Birth" },
  { key: "dateOfJoining", label: "Date Of Joining" },
  { key: "shift", label: "Shift" },
  { key: "employeeType", label: "Employee Type" },
  { key: "vehicleType", label: "Vehicle Type" },
  { key: "status", label: "Status" },
];

const getValue = (value) =>
  value === null || value === undefined || value === "" ? "-" : String(value);

const getErrors = (row) => {
  const messages = [];
  const errors = row?.errors;

  if (errors && typeof errors === "object") {
    Object.values(errors).forEach((value) => {
      if (Array.isArray(value)) {
        value.forEach((msg) => msg && messages.push(String(msg)));
      } else if (value) {
        messages.push(String(value));
      }
    });
  }

  if (row?.validationErrors) {
    String(row.validationErrors)
      .split("|")
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => messages.push(part));
  }

  if (row?.userRemarks) {
    String(row.userRemarks)
      .split("|")
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => messages.push(part));
  }

  if (row?.remarks) {
    String(row.remarks)
      .split("|")
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => messages.push(part));
  }

  return [...new Set(messages)];
};

const EmployeeUploadedErrorTable = ({ data = [] }) => {
  if (!data.length) return null;

  return (
    <div className="rfid-bulk-error-table-wrap">
      <div className="rfid-bulk-error-count">
        <i className="fa-solid fa-triangle-exclamation"></i>
        Total errors: {data.length}
      </div>

      <div className="rfid-bulk-error-table-scroll table-responsive">
        <table className="table table-sm mb-0 rfid-bulk-error-table">
          <thead>
            <tr>
              {COLUMNS.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
              <th className="rfid-bulk-error-col">Errors</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const errors = getErrors(row);
              const rowKey = row?.rowNumber ?? index;

              return (
                <tr key={`${rowKey}-${index}`}>
                  {COLUMNS.map((col) => (
                    <td key={col.key}>
                      {col.key === "rowNumber" ? (
                        `#${getValue(row[col.key] ?? index + 1)}`
                      ) : col.key === "status" ? (
                        <span className="rfid-bulk-status-badge">
                          {getValue(row[col.key])}
                        </span>
                      ) : (
                        getValue(row[col.key])
                      )}
                    </td>
                  ))}
                  <td>
                    {errors.length ? (
                      <div className="d-flex flex-column gap-1">
                        {errors.map((msg, i) => (
                          <span key={i} className="rfid-bulk-error-badge">
                            {msg}
                          </span>
                        ))}
                      </div>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeUploadedErrorTable;
